import Mob from './Mob'
import Vector from './../Support/Vector'

/**
 * GlitchMob class
 *      - a jittering mob that roams around and looks like a random punctuation mark
 */
export default class extends Mob {
    constructor (location) {
        super(location)

        this._roamingTime = 0
        this._currentCharacter = 0
        this._characters = '{}[]&%$#<>~'
        this._jitter = 10
        this._offset = Math.floor(Math.random() * 50)
    }

    draw (currentTime) {
        this.game.getScene().writeText(
            this._getCharacter(currentTime),
            this.getX(),
            this.getY(),
            this._color || 'rgba(255,255,255,.5)',
        )
        if (this.isAlive()) this._roam()
        return this
    }

    die () {
        super.die()
        this._jitter = 50
    }

    _roam () {
        if (this._roamingTime > Math.random() * 100) {
            this.applyForce(new Vector(Math.random() * 4 - 2, Math.random() * 4 - 2))
            this._roamingTime = 0
        } else {
            this._roamingTime++
        }
    }

    _getCharacter (currentTime) {
        if ((currentTime - this._offset) % this._jitter === 0) {
            this._currentCharacter = Math.floor(
                Math.random() * this._characters.length,
            )
        }

        return this._characters.charAt(this._currentCharacter)
    }
}
